import { createSlice } from "@reduxjs/toolkit";

const initialState = {
 courseData: '',
 certificate: null, 

};

const coursesSlice = createSlice({
    name: "accountCourse",
    initialState,
    reducers: {
        setAccountCourse: (state, action) => {
            state.courseData = action.payload;
        },
        setCertificate: (state, action) => {
            state.certificate = action.payload; 
        },
    },
});

export const { 
    setAccountCourse,
    setCertificate, 
} = coursesSlice.actions;

export default coursesSlice.reducer;